import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import helpers from 'helpers/index';
import { TypedNotification } from 'interface/notification.model';
import queryClient, { IQueryParams } from 'queries';



type IQuery = TypedNotification & IQueryParams;


/*
* List of all notification
Cá nhân ...
*/
export function useGetMyNotifications(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["notification/fetch_entities"],
        queryFn: () => axios.get<TypedNotification[]>(`/notification/my_notification${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
    });
}



export function useGetNotifications(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["notification/fetch_entities"],
        queryFn: () => axios.get<TypedNotification[]>(`/notification${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
    });
}


export function useGetNotifitcation() {
    return useMutation({
        mutationKey: ['notification/fetch_entity'],
        mutationFn: (notification_id: string) => axios.get<TypedNotification>(`/notification/${notification_id}`).then((res) => res.data),
    });
}

export function useCreateNotification() {
    return useMutation({
        mutationKey: ['notification/create_entity'],
        mutationFn: (entity: TypedNotification) => axios.post<TypedNotification>(`/notification/`, helpers.cleanEntity(entity)).then((res) => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notification/fetch_entities'] });
        }
    });
}

/** Gửi lại tin */
export function useResendNotifitcation() {
    return useMutation({
        mutationKey: ['notification/resend'],
        mutationFn: (notification_id: string) => axios.post<any>(`/notification/resend/${notification_id}`).then((res) => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notification/fetch_entities'] });
        }
    });
}

/** Gửi lại tin */
export function useCancelsendNotifitcation() {
    return useMutation({
        mutationKey: ['notification/cancel_send'],
        mutationFn: (notification_id: string) => axios.delete<any>(`/notification/cancel_send/${notification_id}`).then((res) => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notification/fetch_entities'] });
        }
    });
}
